import { Box, Button, Typography } from '@mui/material';
import { ClearFilterSection } from './ClearFilterSection';
import React, { useState } from 'react';
import FilterListIcon from '@mui/icons-material/FilterList';
import { FilterMenu } from './FilterMenu';
import { SearchRequest } from 'types/Search';
import { ProductType } from 'types/Products';

export const UxBeautyFilters: React.FC<{
  searchRequest: SearchRequest;
  productType: ProductType;
}> = ({ searchRequest, ...props }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'start',
          paddingBottom: 2
        }}
      >
        <Typography
          variant="h5"
          sx={{
            color: ({ palette }) => palette.primary.light,
            mx: 2,
            whiteSpace: 'nowrap',
            pt: '8px'
          }}
        >
          Filter by
          <FilterListIcon
            sx={{
              marginLeft: 1,
              '&:hover': { color: 'inherit', cursor: 'default' }
            }}
          />
        </Typography>
        <Button
          variant="outlined"
          onClick={event => setAnchorEl(event.target as HTMLElement)}
          sx={{
            display: { xs: 'flex', sm: 'none', alignItems: 'center' }
          }}
        >
          Select Filters
        </Button>
        <FilterMenu
          anchorEl={anchorEl}
          setAnchorEl={setAnchorEl}
          productType={props.productType}
        />
      </Box>
      {searchRequest.filters?.length > 0 && (
        <Box sx={{ marginLeft: '13px' }}>
          <ClearFilterSection />
        </Box>
      )}
    </>
  );
};
